export const AbsenteeRow = ({ u, canQuickMark, onMark }) => (
  <div className="px-4 py-2.5 flex items-center gap-3 text-sm" data-testid={`absent-row-${u.user_id}`}>
    <span className="w-2 h-2 rounded-full bg-red-500 shrink-0" />
    <span className="font-semibold">{u.name}</span>
    <span className="text-xs text-stone-500">{u.employee_code} · {u.department || "—"}</span>
    {canQuickMark && (
      <div className="ml-auto flex items-center gap-2">
        <button onClick={() => onMark(u, false)} data-testid={`quick-mark-${u.user_id}`}
          className="tap-scale px-3 py-1.5 rounded-full bg-secondary text-white text-[11px] font-bold hover:bg-[#1E2B22] transition-colors duration-200">
          Mark present 9–6
        </button>
        <button onClick={() => onMark(u, true)} data-testid={`quick-mark-half-${u.user_id}`}
          className="tap-scale px-3 py-1.5 rounded-full bg-white border border-stone-300 text-stone-700 text-[11px] font-bold hover:bg-stone-50 transition-colors duration-200">
          ½ day
        </button>
      </div>
    )}
  </div>
);

export const OnLeaveRow = ({ u }) => (
  <div className="px-4 py-2 flex items-center gap-3 text-sm">
    <span className="w-2 h-2 rounded-full bg-amber-400 shrink-0" />
    <span className="font-semibold">{u.name}</span>
    <span className="text-xs text-stone-500">{u.employee_code}</span>
    <span className="ml-auto px-2 py-0.5 rounded-full bg-amber-50 text-amber-800 text-[11px] font-bold">{u.leave_type}</span>
  </div>
);
